/**
 * Requires
 */

import $ from 'jquery'

let offset = 0
let openState = false
let buttonClosed = false

/**
 * Initialisation
 */

export function initialise() {
  const $alert = $('[data-sticky-alert]')
  const alertId = $alert.attr('data-sticky-alert')
  const isPreview = $alert.attr('data-sticky-alert-preview')
  const localStorageKey = `hideAlert${alertId}`
  const $button = $('[data-sticky-alert-hide]')
  const is_hidden = localStorage.getItem(localStorageKey)

  if (!is_hidden && !isPreview && !buttonClosed) {
    const elementOffset = 500
    $(window).on('scroll', function() {
      offset = $(document).scrollTop()
      let height = $(document).height()
      let atBottom = offset + +$(window).height() === height
      if (elementOffset < offset && !openState) {
        $alert.addClass('open')
        openState = true
      } else if ((elementOffset > offset || atBottom) && openState) {
        $alert.removeClass('open')
        openState = false
      }
    })
  }

  $button.on('click', function(event) {
    if (!isPreview) {
      localStorage.setItem(localStorageKey, Date.now())
    }
    $alert.removeClass('open')
    buttonClosed = true
  })
}
